var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid zakelijk-wrapper"},[_vm._l((_vm.insuranceKeys),function(key,index){return _c('InsuranceEntryZakelijk',{key:key,attrs:{"name":key,"value":_vm.fields.insurances[key],"is-folded":index !== 0}})}),_c('p',[_vm._v(_vm._s(_vm.getPhrase('Zakelijk.MoreInfo')))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }